<script lang="ts" setup>
defineProps<{
  to?: string
  icon: string
  label: string
  isActive?: boolean
}>()

defineEmits<{
  click: []
}>()
</script>

<template>
  <UButton
    :to="to"
    color="white-nav"
    variant="ghost"
    class="group/navItem relative mb-px flex flex-1 justify-between px-2"
    :class="isActive ? ['bg-blue-80', 'dark:bg-gray-900'] : []"
    @click="$emit('click')"
  >
    <div v-if="isActive" class="absolute inset-y-1.5 left-[-5px] w-[3px] rounded-md bg-blue-600" />
    <div class="flex flex-1 items-center gap-x-2 truncate">
      <slot name="leading">
        <UIcon :name="icon" class="size-4 shrink-0 grow-0 text-gray-500 dark:text-gray-400" />
      </slot>
      <span class="truncate text-left text-nav font-light text-gray-900 dark:text-white">
        {{ label }}
      </span>
    </div>
  </UButton>
</template>
